import { Middleware } from '@nuxt/types';

const middleware: Middleware = (context) => {
  if (context.app.$vsf.$magento.config.state.getCustomerToken()) {
    const customerPage = context.localeRoute({ name: 'customer-my-profile' });
    context.redirect(customerPage);
  }
};
export default middleware;
